import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { environment } from './environments/environment'
import { AppModule } from './app/app.module';
import { captureInitialAttribution } from './app/services/common/attribution.service';

if (environment.production) {
  enableProdMode()
}

// Capture de l'attribution le plus tôt possible, avant toute navigation/redirection.
// L'attribution existante est conservée 90 jours, puis recapturée.
captureInitialAttribution();

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
bootstrap().catch(err => console.log(err))